; "use strict";

import State from './state';
// import MainData from './maindata';
// import CustUK from './custuk';
import CustKD from './custkd';

class Calc {

	constructor() {

		this.mainDataBuf = [];
		this.custDataBuf = [];
		this.getRegData();
	}


/////////////////////////////

	resetData() {

	}

/////////////////////////////
// Заполняем для текущего региона буфера стоимости для всех КСГ

	fillKsgBuf() {

		var cnt, len, regData, code;

		regData = State.MainData[State.currRegNum];
		len = State.dsList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			code = State.dsList[cnt];
			State.dsBuf[code] = this.calcIncome(regData, State.dsList[cnt]);
		}
		len = State.stList.length;
		for(cnt=0 ; cnt<len ; cnt++) {
			code = State.stList[cnt];
			State.stBuf[code] = this.calcIncome(regData, State.stList[cnt]);
		}

	}


/////////////////////////////
// Расчитываем стоимость случая для одного КСГ


	calcIncome(regdata, code) {

		let kz, dzp, res, bs, kus, uk, kd, customUK = -1, customKD = -1, index;

		if(code=='') return 0;
		if(code==undefined) return 0;
		kz = this.getKsgValue(code);
		dzp = this.getDzpValue(code);
		index = regdata.id;
		if(State.CustUK[index]) if(State.CustUK[index][code]) customUK = State.CustUK[index][code];
		if(CustKD[index]) if(CustKD[index][code]) customKD = CustKD[index][code];
		if(-1 != code.indexOf('ds')) {
			bs = regdata.bs_ds;
			kus = regdata.kus_ds;
			uk = regdata.uk_ds;
			kd = regdata.kd_ds
		}
		else if(-1 != code.indexOf('st')) {
			bs = regdata.bs_ks;
			kus = regdata.kus_ks;
			uk = regdata.uk_ks;
			kd = regdata.kd_ks
		}
		else return 0;

// СС = БС*КЗ*((1-ДЗП)+ДЗП*ПК*КД*КС)
//		res = bs*kz*((1.0 - dzp) + dzp*kus*kd);
		if(customUK==-1) res = bs*kz*((1.0 - dzp) + dzp*kus*kd);
		else {
			res = bs*kz*((1.0 - dzp) + dzp*kus*kd*customUK);
		}
		// if(customKD==-1) res *= kd;
		// else res *= customKD;
//		res = Math.round(res);
		return res;
	}


///////////////////////////////////

	getKsgValue(ksg) {

		const ksgData = {
			'ds19.063': 0.15,
			'ds19.064': 0.69,
			'ds19.065': 1.57,
			'ds19.066': 2.82,
			'ds19.067': 0.31,
			'ds19.068': 1.36,
			'ds19.069': 3.06,
			'ds19.070': 5.66,
			'ds19.071': 4.18,
			'ds19.072': 5.13,
			'ds19.073': 6.88,
			'ds19.074': 10.03,
			'ds19.075': 34.21,
			'ds19.076': 35.0,
			'ds19.077': 37.1,
			'ds19.078': 39.91,

			'ds19.080': 0.49,
			'ds19.081': 1.41,
			'ds19.082': 2.03,
			'ds19.083': 2.63,
			'ds19.084': 4.19,
			'ds19.085': 4.93,
			'ds19.086': 5.87,
			'ds19.087': 7.66,
			'ds19.088': 8.57,
			'ds19.089': 9.65,
			'ds19.090': 10.57,
			'ds19.091': 13.5,
			'ds19.092': 16.03,
			'ds19.093': 20.54,
			'ds19.094': 27.22,
			'ds19.095': 34.01,
			'ds19.096': 56.65,

			'st19.090': 0.43,
			'st19.091': 1.37,
			'st19.092': 2.85,
			'st19.093': 4.87,
			'st19.094': 1.46,
			'st19.095': 3.65,
			'st19.096': 7.18,
			'st19.097': 3.52,
			'st19.098': 5.79,
			'st19.099': 9.0,
			'st19.100': 14.84,
			'st19.101': 17.5,
			'st19.102': 20.6,

			'st19.105': 0.4,
			'st19.106': 0.76,
			'st19.107': 1.07,
			'st19.108': 1.37,
			'st19.109': 2.16,
			'st19.110': 2.68,
			'st19.111': 3.53,
			'st19.112': 4.44,
			'st19.113': 4.88,
			'st19.114': 5.25,
			'st19.115': 5.74,
			'st19.116': 6.76,
			'st19.117': 8.07,
			'st19.118': 10.11,
			'st19.119': 13.86,
			'st19.120': 17.2,
			'st19.121': 29.17
		}

		if(ksgData[ksg]) return ksgData[ksg];
		else return 0;
	}

///////////////////////////////////

	getDzpValue(ksg) {

		const dzpData = {
			'ds19.063': 100,
			'ds19.064': 100,
			'ds19.065': 100,
			'ds19.066': 100,
			'ds19.067': 51.06,
			'ds19.068': 51.06,
			'ds19.069': 51.06,
			'ds19.070': 51.06,
			'ds19.071': 4.13,
			'ds19.072': 12.75,
			'ds19.073': 22.53,
			'ds19.074': 31.49,
			'ds19.075': 0.42,
			'ds19.076': 1.56,
			'ds19.077': 4.36,
			'ds19.078': 7.65,

			'ds19.080': 19.12,
			'ds19.081': 8.79,
			'ds19.082': 25.89,
			'ds19.083': 23.50,
			'ds19.084': 3.14,
			'ds19.085': 2.04,
			'ds19.086': 6.59,
			'ds19.087': 11.06,
			'ds19.088': 15.08,
			'ds19.089': 14.91,
			'ds19.090': 22.35,
			'ds19.091': 9.99,
			'ds19.092': 8.49,
			'ds19.093': 5.64,
			'ds19.094': 2.82,
			'ds19.095': 5.84,
			'ds19.096': 0.23,

			'st19.090': 100,
			'st19.091': 100,
			'st19.092': 100,
			'st19.093': 100,
			'st19.094': 75.89,
			'st19.095': 75.89,
			'st19.096': 75.89,
			'st19.097': 28.29,
			'st19.098': 46.99,
			'st19.099': 57.29,
			'st19.100': 4.98,
			'st19.101': 15.77,
			'st19.102': 24.83,

			'st19.105': 55.63,
			'st19.106': 41.67,
			'st19.107': 23.71,
			'st19.108': 18.75,
			'st19.109': 32.50,
			'st19.110': 8.76,
			'st19.111': 7.11,
			'st19.112': 7.77,
			'st19.113': 5.84,
			'st19.114': 5.79,
			'st19.115': 7.27,
			'st19.116': 5.90,
			'st19.117': 3.32,
			'st19.118': 2.15,
			'st19.119': 1.55,
			'st19.120': 1.19,
			'st19.121': 0.69
		}

		if(dzpData[ksg]) return dzpData[ksg]/100.0;
		else return 0;
	}

///////////////////////////////////
// Проверяем, нет ли сохраненных данных по распределению пациентов в LS

	checkDataSaved() {

		const key = 'mn_meth';

		let dataSet = localStorage.getItem(key);
		return (null != dataSet)
	}

///////////////////////////////////

	getUserData(e){

		let deploy, apiUrl, n;

		deploy = this.getAppLocation();
	    
	    if(deploy == 'production') apiUrl = './userdata/api/user/';
	    if(deploy == 'testing') apiUrl = './userdata/api/user/';
	    if(deploy == 'local') apiUrl = '../userdata/api/user/';

		if(e.charCode==13 || e.target.id=='login-butt') {

			n = $('#login-input').val();
	    	$.ajax({
	           url: apiUrl+n,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
              		State.authToken = data.onpass;
              		checkLogin();
	              },
	           error: function(data){ 
	           		console.log('No connection to user DB');
	           		console.log(data); 
	           		this.netError = 1;
	           	}
	        });             
		}
	}

///////////////////////////////////

	getAppLocation() {

		let addr, deploy;

		addr = window.location.href;
		if(addr.indexOf('ksgcalc.ru')!=-1) deploy = 'local'; 
		if(addr.indexOf('critical.ru')!=-1) deploy = 'testing'; 
		if(addr.indexOf('calculatoroms.ru')!=-1) deploy = 'production'; 

		return deploy;
	}

///////////////////////////////////

	getRegData(){

	    var apiUrl = '../data/api/',
	    	regionUrl, customUkUrl, res, deploy,
	    	regsBufer = {},
	    	ukBufer = {};

		deploy = this.getAppLocation();
	    
	    if(deploy == 'production') apiUrl = './oncodata/api/';
	    if(deploy == 'testing') apiUrl = './oncodata/api/';
	    if(deploy == 'local') apiUrl = '../oncodata/api/';

	    regionUrl = apiUrl + 'dataoncos';
	    customUkUrl = apiUrl + 'ukcustoncos';
	    State.flDataLoad = 0;
	    $.ajax({
	           url: regionUrl,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
	           	  State.flDataLoad++	
	              this.mainDataBuf = data.rows;
	              if(State.flDataLoad>1) {
//	              if(State.flDataLoad>0) {
		            	this.loadMainData();
		            	this.loadCustData();
	              		State.hideLoadBanner();
	              	}
	              },
	           error: function(data){ 
	           		console.log('No connection to region DB');
	           		console.log(data); 
	           		this.netError = 1;
	           	}
	          });             

	    $.ajax({
	           url: customUkUrl,
	           type: "get",
	           async: true,
	           data: {},
	           dataType: "json",
	           contentType: "application/json",
	           success: (data)=>{ 
	           	  State.flDataLoad++	
	              this.custDataBuf = data.rows;
	              if(State.flDataLoad>1) {
	                	this.loadMainData();
		            	this.loadCustData();
	              		State.hideLoadBanner();
	              	}
	              },
	           error: function(data){ 
	           		console.log('No connection to customUK DB');
	           		console.log(data);  this.netError = 1;
	           	}
	          });
	}       

/////////////////////////////

	loadMainData() {

		let input = this.mainDataBuf;
		let len = input.length, i, inp, out;

		State.MainData = [];
		for(i=0 ; i<len ; i++) {
			out = {};
			inp = input[i];
			out.id = inp.id;
			out.sub = inp.subjnum;
			out.name = inp.name;
			out.bs_ds = inp.bnDs;
			out.bs_ks = inp.bnKs;
			out.kus_ds = inp.kusDs;
			out.kus_ks = inp.kusKs;
			out.uk_ds = inp.ukDs;
			out.uk_ks = inp.ukKs;
			out.kd_ds = inp.kdDs;
			out.kd_ks = inp.kdKs;
			State.MainData.push(out);			
		}
	}

/////////////////////////////

	loadCustData() {

		let input = this.custDataBuf;
		let len = input.length, i, inp, out, custData, regId, ksgSet;
		
		State.CustUK = {};
		for(i=0 ; i<len ; i++) {
			custData = input[i];
			regId = custData.id;
			ksgSet = {};
		
			ksgSet['ds19.063'] = custData.ds19063;
			ksgSet['ds19.064'] = custData.ds19064;
			ksgSet['ds19.065'] = custData.ds19065;
			ksgSet['ds19.066'] = custData.ds19066;
			ksgSet['ds19.067'] = custData.ds19067;
			ksgSet['ds19.068'] = custData.ds19068;
			ksgSet['ds19.069'] = custData.ds19069;
			ksgSet['ds19.070'] = custData.ds19070;
			ksgSet['ds19.071'] = custData.ds19071;
			ksgSet['ds19.072'] = custData.ds19072;
			ksgSet['ds19.073'] = custData.ds19073;
			ksgSet['ds19.074'] = custData.ds19074;
			ksgSet['ds19.075'] = custData.ds19075;
			ksgSet['ds19.076'] = custData.ds19076;
			ksgSet['ds19.077'] = custData.ds19077;
			ksgSet['ds19.078'] = custData.ds19078;

			ksgSet['ds19.080'] = custData.ds19080;
			ksgSet['ds19.081'] = custData.ds19081;
			ksgSet['ds19.082'] = custData.ds19082;
			ksgSet['ds19.083'] = custData.ds19083;
			ksgSet['ds19.084'] = custData.ds19084;
			ksgSet['ds19.085'] = custData.ds19085;
			ksgSet['ds19.086'] = custData.ds19086;
			ksgSet['ds19.087'] = custData.ds19087;
			ksgSet['ds19.088'] = custData.ds19088;
			ksgSet['ds19.089'] = custData.ds19089;
			ksgSet['ds19.090'] = custData.ds19090;
			ksgSet['ds19.091'] = custData.ds19091;
			ksgSet['ds19.092'] = custData.ds19092;
			ksgSet['ds19.093'] = custData.ds19093;
			ksgSet['ds19.094'] = custData.ds19094;
			ksgSet['ds19.095'] = custData.ds19095;
			ksgSet['ds19.096'] = custData.ds19096;

			ksgSet['st19.090'] = custData.st19090;
			ksgSet['st19.091'] = custData.st19091;
			ksgSet['st19.092'] = custData.st19092;
			ksgSet['st19.093'] = custData.st19093;
			ksgSet['st19.094'] = custData.st19094;
			ksgSet['st19.095'] = custData.st19095;
			ksgSet['st19.096'] = custData.st19096;
			ksgSet['st19.097'] = custData.st19097;
			ksgSet['st19.098'] = custData.st19098;
			ksgSet['st19.099'] = custData.st19099;
			ksgSet['st19.100'] = custData.st19100;
			ksgSet['st19.101'] = custData.st19101;
			ksgSet['st19.102'] = custData.st19102;

			ksgSet['st19.105'] = custData.st19105;
			ksgSet['st19.106'] = custData.st19106;
			ksgSet['st19.107'] = custData.st19107;
			ksgSet['st19.108'] = custData.st19108;
			ksgSet['st19.109'] = custData.st19109;
			ksgSet['st19.110'] = custData.st19110;
			ksgSet['st19.111'] = custData.st19111;
			ksgSet['st19.112'] = custData.st19112;
			ksgSet['st19.113'] = custData.st19113;
			ksgSet['st19.114'] = custData.st19114;
			ksgSet['st19.115'] = custData.st19115;
			ksgSet['st19.116'] = custData.st19116;
			ksgSet['st19.117'] = custData.st19117;
			ksgSet['st19.118'] = custData.st19118;
			ksgSet['st19.119'] = custData.st19119;
			ksgSet['st19.120'] = custData.st19120;
			ksgSet['st19.121'] = custData.st19121;

			State.CustUK[regId] = ksgSet;
		}
	State.regSelector.initRegData();
	
//console.log(State.CustUK);
	}

/////////////////////////////

	restoreAllData() {

	}

/////////////////////////////


	initDataSet() {

	}


/////////////////////////////

    padDigits(str){

        var res='',s='',i,cnt,n;

        str = '' + str;
        n = str.length;

        for(i=0,cnt=0;i<n;i++){
            s = s + str.slice(-1);
            str = str.slice(0,str.length-1);
            cnt++;
            if(cnt>=3){
                cnt = 0;
                s = s + ' ';
            }
        }
        n = s.length;
        for(i=0;i<n;i++){
            res = res + s.slice(-1);
            s = s.slice(0,s.length-1);
        }
	    return(res);
    }

/////////////////////////////

    padFloat(str){

        var res='',s='',i,cnt,n, ext, point;

        ext = '';
        str = '' + str;
        point = str.indexOf('.');
        if(point==-1) { str = str + '.00'};
        point = str.indexOf('.');
        if(point>-1) {
            ext = str.slice(point+1, str.length);
            str = str.slice(0, point);
            if(ext.length > 2) ext = ext.slice(0, 1);
            if(ext.length == 1) ext = ext + '0';
            if(ext.length == 0) ext = ext + '00';
        }
        n = str.length;
        for(i=0,cnt=0;i<n;i++){
            s = s + str.slice(-1);
            str = str.slice(0,str.length-1);
            cnt++;
            if(cnt>=3){
                cnt = 0;
                s = s + ' ';
            }
        }
        n = s.length;
        for(i=0;i<n;i++){
            res = res + s.slice(-1);
            s = s.slice(0,s.length-1);
        }
        if(ext!='') {
            res += ',';
            res += ext;
        }
    return(res);

    }

}

export default Calc;